(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('#shopify-section-header');
      this.navigation = this.header.querySelector('.header-section-inner__bottom');
      this.searchBoxes = this.header.querySelectorAll('.search-inner input');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('.site-search__wrapper');



      window.addEventListener('scroll', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
      this.searchBoxes.forEach( searchBox => {
        searchBox.addEventListener('focus', this.toggleSearch);
      })
      this.setHeaderHeight();
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--upper-header-height', `${this.header.offsetHeight - this.navigation.offsetHeight - 1}px`);
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    toggleSearch() {
      document.body.classList.toggle('search-open'); 
    }

  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
